'use client';
import React, { useEffect, useRef, useState } from 'react';

interface Service {
  icon: React.ReactNode;
  title: string;
  description: string;
  features: string[];
  color: string;
  gradient: string;
  waMessage: string;
}

const services: Service[] = [
  {
    icon: (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
      </svg>
    ),
    title: 'تصميم المواقع',
    description: 'تصميم منصة تفاعلية سريعة ومصممة خصيصاً لإقناع الزائر، إبراز قيمة خدماتك، ودفعه لاتخاذ قرار الشراء أو التواصل معك فوراً؛ لنحول كل زيارة لموقعك إلى فرصة مبيعات حقيقية تزيد من إيراداتك',
    features: ['واجهات سهلة تُوجه الزائر لطلب الخدمة مباشرة', 'تجربة سلسة وسريعة تجذب العميل على الهواتف', 'سرعة فائقة تمنع الزائر من مغادرة الموقع', 'ظهور متقدم في نتائج البحث لجذب عملاء مهتمين'],
    color: 'text-amber-400',
    gradient: 'from-amber-600/20 to-amber-900/10',
    waMessage: 'مرحباً، أود الاستفسار عن خدمة تصميم المواقع',
  },
  {
    icon: (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z" />
      </svg>
    ),
    title: 'التسويق الرقمي',
    description: 'استراتيجيات تسويق رقمي متكاملة تزيد من ظهورك وتجذب عملاء جدد',
    features: ['تحسين محركات البحث SEO', 'إعلانات مدفوعة Google Ads', 'تسويق بالبريد الإلكتروني', 'تحليل البيانات'],
    color: 'text-yellow-300',
    gradient: 'from-yellow-600/20 to-yellow-900/10',
    waMessage: 'مرحباً، أود الاستفسار عن خدمة التسويق الرقمي',
  },
  {
    icon: (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z" />
      </svg>
    ),
    title: 'إدارة السوشيال ميديا',
    description: 'ندير حساباتك على منصات التواصل الاجتماعي باحترافية ونبني جمهوراً متفاعلاً',
    features: ['محتوى إبداعي يومي', 'إدارة التعليقات', 'تقارير شهرية', 'حملات إعلانية'],
    color: 'text-amber-300',
    gradient: 'from-amber-500/20 to-amber-900/10',
    waMessage: 'مرحباً، أود الاستفسار عن خدمة إدارة السوشيال ميديا',
  },
  {
    icon: (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
      </svg>
    ),
    title: 'الهوية البصرية',
    description: 'نصمم هوية بصرية متكاملة تعكس قيم علامتك وتجعلك لا تُنسى',
    features: ['تصميم الشعار', 'دليل الهوية', 'ألوان وخطوط', 'مواد تسويقية'],
    color: 'text-yellow-400',
    gradient: 'from-yellow-600/20 to-yellow-900/10',
    waMessage: 'مرحباً، أود الاستفسار عن خدمة الهوية البصرية',
  },
  {
    icon: (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
      </svg>
    ),
    title: 'الاستشارات التجارية',
    description: 'نقدم استشارات استراتيجية متخصصة تساعدك على اتخاذ قرارات صحيحة وتحقيق النمو',
    features: ['تحليل السوق', 'خطط النمو', 'تحسين العمليات', 'قيادة التغيير'],
    color: 'text-amber-500',
    gradient: 'from-amber-700/20 to-amber-900/10',
    waMessage: 'مرحباً، أود الاستفسار عن خدمة الاستشارات التجارية',
  },
  {
    icon: (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
      </svg>
    ),
    title: 'الأتمتة والذكاء الاصطناعي',
    description: 'نصمم أنظمة أتمتة ذكية ونُدمج تقنيات الذكاء الاصطناعي في أعمالك لتوفير الوقت والجهد، رفع الإنتاجية، وتحسين تجربة العملاء',
    features: ['أتمتة المبيعات وإدارة العملاء', 'شاتبوت ذكي وتوصيات AI', 'تكامل الأنظمة وتقارير آلية', 'تحليل البيانات وأتمتة AI'],
    color: 'text-yellow-200',
    gradient: 'from-yellow-500/15 to-yellow-900/10',
    waMessage: 'مرحباً، أود الاستفسار عن خدمة الأتمتة والذكاء الاصطناعي',
  },
  {
    icon: (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 18h.01M8 21h8a2 2 0 002-2v-1a1 1 0 00-1-1H7a1 1 0 00-1 1v1a2 2 0 002 2zM12 3a9 9 0 110 18A9 9 0 0112 3z" />
      </svg>
    ),
    title: 'تطبيقات مخصصة',
    description: 'نبني لك تطبيقاً خاصاً بمشروعك، مصمماً لجلب المزيد من الزبائن، تسهيل عمليات الشراء، وضمان تكرار المبيعات بشكل آلي',
    features: ['زيادة المبيعات والطلبات المباشرة', 'بناء ثقة وولاء دائم مع زبائنك', 'تسهيل وإتمام عملية الشراء بضغطة زر', 'نظام إشعارات آلي لإعادة استهداف الزبائن'],
    color: 'text-yellow-300',
    gradient: 'from-yellow-600/20 to-yellow-900/10',
    waMessage: 'مرحباً، أود الاستفسار عن خدمة تطبيقات مخصصة',
  },
];

const DEFAULT_VISIBLE = 3;

export default function ServicesSection() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('opacity-100', 'translate-y-0');
            entry.target.classList.remove('opacity-0', 'translate-y-8');
          }
        });
      },
      { threshold: 0.1 }
    );
    const elements = sectionRef.current?.querySelectorAll('.animate-on-scroll');
    elements?.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, [showAll]);

  const visibleServices = showAll ? services : services.slice(0, DEFAULT_VISIBLE);

  return (
    <section id="services" ref={sectionRef} className="relative py-24 overflow-hidden" style={{ background: '#080808' }}>
      {/* Background */}
      <div className="absolute inset-0 grid-pattern opacity-30"></div>
      <div className="orb orb-gold w-96 h-96 top-0 left-1/2 -translate-x-1/2 opacity-10"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section header */}
        <div className="text-center mb-16">
          <div className="animate-on-scroll opacity-0 translate-y-8 transition-all duration-700 inline-flex items-center gap-2 px-4 py-2 rounded-full section-badge text-sm font-medium mb-6">
            <span className="w-2 h-2 rounded-full bg-amber-400"></span>
            خدماتنا
          </div>
          <h2 className="animate-on-scroll opacity-0 translate-y-8 transition-all duration-700 delay-100 text-4xl md:text-5xl font-black text-white mb-4">
            حلول رقمية <span className="gradient-text">متكاملة</span>
          </h2>
          <p className="animate-on-scroll opacity-0 translate-y-8 transition-all duration-700 delay-200 text-gray-400 text-lg max-w-2xl mx-auto">
            نقدم طيفاً شاملاً من الخدمات الرقمية لمساعدتك على النمو والتوسع
          </p>
        </div>

        {/* Services grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {visibleServices.map((service, index) => {
            const waUrl = `https://wa.me/9647713020752?text=${encodeURIComponent(service.waMessage)}`;

            return (
              <a
                key={index}
                href={waUrl}
                target="_blank"
                rel="noopener noreferrer"
                className={`animate-on-scroll opacity-0 translate-y-8 transition-all duration-700 service-card rounded-2xl p-6 group cursor-pointer block relative`}
                style={{ transitionDelay: `${index * 80}ms` }}
              >
                {/* Icon */}
                <div className={`w-14 h-14 rounded-2xl bg-gradient-to-br ${service.gradient} flex items-center justify-center mb-5 ${service.color} group-hover:scale-110 transition-transform duration-300`}>
                  {service.icon}
                </div>

                {/* Title */}
                <h3 className="text-white font-bold text-lg mb-3 group-hover:text-amber-400 transition-colors">
                  {service.title}
                </h3>

                {/* Description */}
                <p className="text-gray-400 text-sm leading-relaxed mb-4">
                  {service.description}
                </p>

                {/* Features */}
                <ul className="space-y-1.5">
                  {service.features.map((feature, fi) => (
                    <li key={fi} className="flex items-center gap-2 text-gray-500 text-xs">
                      <span className={`w-1.5 h-1.5 rounded-full ${service.color.replace('text-', 'bg-')} flex-shrink-0`}></span>
                      {feature}
                    </li>
                  ))}
                </ul>

                {/* Hover CTA */}
                <div className={`mt-5 flex items-center gap-1 ${service.color} text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-300`}>
                  <span>اعرف أكثر</span>
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                  </svg>
                </div>
              </a>
            );
          })}
        </div>

        {/* Show More / Show Less Button */}
        <div className="text-center mt-10">
          <button
            onClick={() => setShowAll((prev) => !prev)}
            className="inline-flex items-center gap-2 px-8 py-3 rounded-full border border-amber-500/40 text-amber-400 hover:bg-amber-500/10 hover:border-amber-400 transition-all duration-300 text-sm font-semibold"
          >
            {showAll ? (
              <>
                <span>عرض أقل</span>
                <svg className="w-4 h-4 rotate-180" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </>
            ) : (
              <>
                <span>عرض المزيد</span>
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </>
            )}
          </button>
        </div>
      </div>
    </section>
  );
}
